import { IDelete } from '../service/base/data.service';

export const standardCommand = {
  create: 'create',
  delete: 'delete',
  download: 'download',
  edit: 'edit',
  copy: 'copy',
  export: 'export',
};

export abstract class CommandBase {
  constructor(readonly id: string, readonly contextId?: string) {
    if (!this.id) throw new Error('The command id was not specified.');
  }
}

export class Command<TContext = any> extends CommandBase {
  constructor(id: string, contextId?: string) {
    super(id, contextId);
  }

  context: TContext;
}

export class DeleteCommand<TItem = any, TContext = any> extends Command<TContext> {
  constructor(id: string, contextId?: string) {
    super(id, contextId);
  }
  dataService: IDelete;
  itemsSource: TItem[];
}

export class FilteredCommand extends CommandBase {
  constructor(id: string, readonly excludedIds: string[], readonly includedIds: string[], readonly totalAffectedItemsControlValue: number) {
    super(id);
  }

  public dataService: any;
  public filterProvider: { filterState: any };
}

export class MultiselectCommand<TItem = any> extends CommandBase {
  constructor(id: string, readonly items: TItem[], readonly itemsSource: TItem[], contextId?: string) {
    super(id, contextId);
  }
}
